module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 129.2be2ff7c.png";